import { FC, useState } from 'react';
import { Form, Input, Modal, ModalProps, Typography } from 'antd';
import formRule from '@/libs/antd/rules';
import { useApp } from '@/App';
import { forgotPassword } from '@/libs/fleet-api/services/users';

const ForgotPasswordModal: FC<ModalProps> = (props) => {
	const { notification } = useApp();
	const [forgotPasswordForm] = Form.useForm<{ email: string }>();

	return (
		<Modal
			title="Forgot Password"
			{...props}
			onOk={(e) => {
				props.onOk?.(e);
				forgotPasswordForm.submit();
			}}
		>
			<Typography.Paragraph>Please enter your email</Typography.Paragraph>
			<Form
				form={forgotPasswordForm}
				layout="vertical"
				onFinish={async ({ email }) => {
					try {
						const isSent = await forgotPassword(email);
						if (isSent) {
							notification.success({
								message: 'Please check your email',
							});
						}
					} catch (error) {
						notification.error({
							message: 'Oops! something went wrong',
						});
						console.log(error);
					}
				}}
			>
				<Form.Item
					label="Email"
					name="email"
					rules={[formRule.required()]}
				>
					<Input
						type="email"
						placeholder="example@email.com"
					/>
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default ForgotPasswordModal;

export const useForgotPasswordModal = () => {
	const [open, setOpen] = useState(false);

	return [
		{
			open,
			onCancel: () => setOpen(false),
			onOk: () => setOpen(false),
		} as ModalProps,
		setOpen,
	] as const;
};
